'use strict';
var util = require('../util');

module.exports = {
  appVersion: '8.0.0',

  setScrollEnabled: util.actionMapping('setScrollEnabled'),
  setBouncesEnabled: util.actionMapping('setBouncesEnabled'),

  bindPhone: util.actionMapping('bindPhone'),
  pay: util.actionMapping('pay')
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/dpapp/lib/patch/patch-8.0.0.js
// module id = 160
// module chunks = 10 11 12 13 14 15 16 17 18 19